import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import {
    Recommendation,
    RecommendationModalType,
    RecommendationType
} from '../../typings/recommendations';
import { ModalDecorator } from '../ModalDecorator/ModalDecorator';
import { AddAppropriateCreativesRecommendationCard } from '../RecommendationCard/AddAppropriateCreativesRecommendationCard/AddAppropriateCreativesRecommendationCard';
import { AddAppropriatePlacementRecommendationCard } from '../RecommendationCard/AddAppropriatePlacementRecommendationCard/AddAppropriatePlacementRecommendationCard';
import { AddCreativesRecommendationCard } from '../RecommendationCard/AddCreativesRecommendationCard/AddCreativesRecommendationCard';
import { RecommendationCardView } from '../RecommendationCard/RecommendationCard';

import './RecommendationsModal.css';
import * as keyset from './RecommendationsModal.i18n';

const i18n = i18nFactory(keyset);

export interface RecommendationsModalProps {
    isVisible: boolean;
    data: Array<RecommendationModalType>;
    onClose: () => void;
    headerHint: string;
}

const BLOCK = 'recommendations-modal';

export const RecommendationsModal = React.memo(
    (props: RecommendationsModalProps): JSX.Element | null => {
        const { isVisible, onClose, data, headerHint } = props;
        if (!(data.length && isVisible)) {
            return null;
        }

        return (
            <ModalDecorator
                theme={'full-width-body'}
                header={i18n('recommendation')}
                hasClose={true}
                headerHint={headerHint}
                zIndexGroupLevel={1}
                autoclosable={true}
                scrollable={true}
                fixedWidth={650}
                visible={isVisible}
                onClose={onClose}
            >
                <div className={Bem.cls(BLOCK, 'modal-content')}>
                    <div className={Bem.cls(BLOCK, 'cards')}>
                        {data.map((item, index) => {
                            const { title, recommendation, titleHint } = item;
                            return (
                                <div
                                    key={index}
                                    className={Bem.cls(BLOCK, 'card')}
                                >
                                    {getRecommendationCardByView(
                                        recommendation,
                                        title,
                                        titleHint
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </ModalDecorator>
        );
    }
);

const getRecommendationCardByView = (
    recommendation: Recommendation,
    title?: string,
    titleHint?: string
): JSX.Element | null => {
    const recommendationCardView = RecommendationCardView.recommendationsModal;

    switch (recommendation.type) {
        case RecommendationType.addBannerFormats:
            return (
                <AddCreativesRecommendationCard
                    character={recommendation.character}
                    view={recommendationCardView}
                    formats={recommendation.kpi.formats}
                    title={title}
                    titleHint={titleHint}
                />
            );

        case RecommendationType.uploadAppropriateCreatives:
            return (
                <AddAppropriateCreativesRecommendationCard
                    character={recommendation.character}
                    view={recommendationCardView}
                    videoFormats={recommendation.kpi.videoFormats}
                    title={title}
                    titleHint={titleHint}
                />
            );

        case RecommendationType.chooseAppropriatePlacementsForAdGroup:
            return (
                <AddAppropriatePlacementRecommendationCard
                    character={recommendation.character}
                    view={recommendationCardView}
                    videoFormats={recommendation.kpi.videoFormats}
                    title={title}
                    titleHint={titleHint}
                    type={recommendation.type}
                />
            );

        default:
            return null;
    }
};
